import './styles.scss';
import ColumnWrapper from 'Layout/ColumWraper';
import FutureSideText from './FeaturesSideText';
import FeautersItems from './FeaturesItems/index';
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';


const Feauters = ({ featuresSideText, features, isLoading }) => {
    const container = useRef();

    useAnimation({
        items: ['.features-sidetext h2', '.features-sidetext p', '.features-item'],
        container,
        dependencies: [isLoading],
    })
    // if (Object.entries(features).length === 0) return
    const { tag, title, description } = featuresSideText
    return (
        <section ref={container} className="features">
            <ColumnWrapper SideText={<FutureSideText title={title} desc={description} tag={tag} />} >
                <FeautersItems features={features} />
            </ColumnWrapper>
        </section>
    );
};

export default Feauters;
